import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  onMounted,
  shallowRef,
  ref,
  onBeforeUnmount,
  computed,
  onUnmounted,
} from 'vue'
import * as echarts from 'echarts'


export default /*#__PURE__*/_defineComponent({
  props: {
  // ... 您的 props 定义保持不变
  height: {
    type: Number,
    default: 400,
  },
  value: {
    type: Number,
    default: 8,
  },
  color: {
    type: String,
    default: '#2056ff',
  },
  hasLine: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props



// === 数据和 Refs 定义 ===
const echart = ref<HTMLElement | null>(null)
const chart = shallowRef<echarts.ECharts | null>(null)
let timer: number | undefined

// 初始7个数据点
const chartData = ref<number[]>(
  Array.from({ length: 7 }, () => (props.value <= 0 ? 0 : props.value)),
)
// 初始7个X轴标签
const xAxisLabels = ref<string[]>(Array.from({ length: 7 }, (v, k) => `${k}`))

// === ECharts 配置 ===
const option = computed(() => {
  // 将 series 的定义移入 computed property 内部，确保响应性
  const series = props.hasLine
    ? [
        {
          data: chartData.value,
          type: 'bar',
          smooth: true,
        },
        {
          data: chartData.value,
          type: 'line',
          smooth: true,
        },
      ]
    : [
        {
          data: chartData.value,
          type: 'bar',
          smooth: true,
        },
      ]

  return {
    universalTransition: {
      enabled: true,
      seriesKey: ['bar', 'line'],
    },
    animationDurationUpdate: 1000,
    animationEasingUpdate: 'cubicInOut',
    color: [props.color],
    grid: {
      top: 10,
      bottom: 10,
      left: 10,
      right: 10,
      containLabel: false,
    },
    xAxis: {
      type: 'category',
      data: xAxisLabels.value,
      triggerEvent: true,
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        show: false,
      },
    },
    yAxis: {
      type: 'value',
      // min: function (value) {
      //   return value.min - 10 // 或根据实际数据微调
      // },
      // max: function (value) {
      //   return value.max + 10
      // },
      // scale: true,
      splitLine: { show: false },
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { show: false },
    },
    // 将 series 放置在这里
    series,
  }
})

const initChart = () => {
  const chartDom = echart.value
  if (chartDom) {
    chart.value = echarts.init(chartDom)
    // 初始渲染
    chart.value.setOption(option.value)
  }
}
function updateChartData() {
  const randomValue = props.value <= 0 ? 0 : props.value
  // const randomValue = props.value +Math.floor(Math.random() * 100)
  const randomLabel = Date()

  chartData.value = [...chartData.value.slice(1), randomValue]
  xAxisLabels.value = [...xAxisLabels.value.slice(1), randomLabel]
  if (chart.value) {
    chart.value.setOption(option.value)
  }
}

// === 生命周期钩子 ===
onMounted(() => {
  initChart()
  timer = window.setInterval(updateChartData, 1000)
  window.addEventListener('resize', () => {
    if (echart.value) {
      const chartInstance = echarts.getInstanceByDom(echart.value)
      if (chartInstance) {
        chartInstance.resize()
      }
    }
  })
})
onUnmounted(() => {
  // 清理事件监听
  window.removeEventListener('resize', () => {
    if (echart.value) {
      const chartInstance = echarts.getInstanceByDom(echart.value)
      if (chartInstance) {
        chartInstance.resize()
      }
    }
  })
})

onBeforeUnmount(() => {
  clearInterval(timer)
  if (chart.value) {
    chart.value.dispose()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "echart",
    ref: echart,
    id: "echart",
    style: {"width":"100%","height":"100%"}
  }, null, 512))
}
}

})